import { TablePagination as MuiTablePagination } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const TablePagination = styled(MuiTablePagination, {
  shouldForwardProp: (prop) => prop !== "outlined",
})<{ outlined?: boolean; component?: string }>(
  ({ theme }) => ({
    width: "100%",
    backgroundColor: theme.palette.background.default,
  }),
  ({ outlined, theme }) => ({
    ...(outlined && {
      boxSizing: "border-box",
      border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    }),
  })
);
